var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo-date d-flex align-center"},[_c('img',{attrs:{"src":require('@/assets/images/logo-mini.png'),"alt":""}}),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"d-block font-20 darktext--text"},[_vm._v("Medical Job")]),_c('span',{staticClass:"d-block font-15 lightgreytext--text"},[_vm._v("Jun 27, 2022")])])
}]

export { render, staticRenderFns }